export function ManagerRankingList({
  rows,
  barClassName = "bg-primary",
  maxValue,
  startRank = 1,
}: {
  rows: readonly { id: string; title: string; meta?: string; value: number; valueText: string }[];
  barClassName?: string;
  maxValue?: number;
  startRank?: number;
}) {
  const max = maxValue ?? Math.max(1, ...rows.map((row) => row.value));
  return (
    <ol className="space-y-4">
      {rows.map((row, index) => (
        <li key={row.id}>
          <div className="mb-1.5 flex items-baseline justify-between gap-3">
            <div className="min-w-0">
              <p className="truncate text-sm font-medium">
                <span className="mr-2 tabular-nums text-muted-foreground">{startRank + index}</span>
                {row.title}
              </p>
              {row.meta ? <p className="truncate pl-6 text-xs text-muted-foreground">{row.meta}</p> : null}
            </div>
            <p className="shrink-0 text-sm font-medium tabular-nums">{row.valueText}</p>
          </div>
          <div aria-hidden="true" className="ml-6 h-2 overflow-hidden rounded-full bg-muted">
            <div
              className={`h-full rounded-full ${barClassName}`}
              style={{ width: `${(row.value / max) * 100}%` }}
            />
          </div>
        </li>
      ))}
    </ol>
  );
}
